
export default {
  name: "ProseBlock",
  props: {
    block: { type: Object, required: true },
  },
  computed: {
    html() {
      // Hygraph editors sometimes leave trailing empty paragraphs —
      // strip them so they don't add phantom vertical gaps.
      return (this.block.html || "").replace(/<p>(?:\s|&nbsp;)*<\/p>/gi, "");
    },
  },
};
